export type CouponErrorCode =
  | 'COUPON_NOT_FOUND'
  | 'COUPON_ARCHIVED'
  | 'COUPON_NOT_YET_VALID'
  | 'COUPON_EXPIRED'
  | 'COUPON_TYPE_UNSUPPORTED'
  | 'COUPON_ALREADY_USED'
  | 'COUPON_CONFIGURATION_INVALID';

export type CouponErrorTranslationKey =
  | 'error.coupon'
  | 'error.couponServiceUnavailable'
  | 'error.couponCodes.notFound'
  | 'error.couponCodes.archived'
  | 'error.couponCodes.notYetValid'
  | 'error.couponCodes.expired'
  | 'error.couponCodes.unsupported'
  | 'error.couponCodes.alreadyUsed'
  | 'error.couponCodes.configurationInvalid';

const couponErrorTranslationKeys: Record<CouponErrorCode, CouponErrorTranslationKey> = {
  COUPON_NOT_FOUND: 'error.couponCodes.notFound',
  COUPON_ARCHIVED: 'error.couponCodes.archived',
  COUPON_NOT_YET_VALID: 'error.couponCodes.notYetValid',
  COUPON_EXPIRED: 'error.couponCodes.expired',
  COUPON_TYPE_UNSUPPORTED: 'error.couponCodes.unsupported',
  COUPON_ALREADY_USED: 'error.couponCodes.alreadyUsed',
  COUPON_CONFIGURATION_INVALID: 'error.couponCodes.configurationInvalid',
};

export const getCouponErrorTranslationKey = (error: unknown): CouponErrorTranslationKey => {
  const response = (error as {
    response?: { status?: number; data?: { data?: { code?: unknown } } };
  })?.response;
  const code = response?.data?.data?.code;

  if (typeof code === 'string' && code in couponErrorTranslationKeys) {
    return couponErrorTranslationKeys[code as CouponErrorCode];
  }

  return !response?.status || response.status >= 500
    ? 'error.couponServiceUnavailable'
    : 'error.coupon';
};
